export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('table_label_taskNo') || '任务编号',
    field: 'taskNo',
    headerAlign: 'center',
    align: 'left',
    width: 160,
    slots: { default: 'taskNo' },
  },
  {
    title: that.$l('table_label_tskOverview') || '任务概要',
    field: 'taskTitle',
    minWidth: 300,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'taskTitle' },
  },
  {
    title: that.$l('table_label_taskByName') || '经办人',
    field: 'tskByName',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_taskStatus') || '任务状态',
    field: 'taskStatus',
    minWidth: 100,
    align: 'center',
    slots: { default: 'taskStatus' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_report_name') || '报告人',
    field: 'createByName',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_tskEndDate') || '到期日期',
    field: 'tskEndDate',
    minWidth: 170,
    align: 'left',
    slots: { default: 'tskEndDate' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_expoInfoName') || '项目名称',
    field: 'expoInfoName',
    minWidth: 230,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_purposeOrIssue') || '会议名称',
    field: 'purposeOrIssue',
    minWidth: 230,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.create_date') || '创建时间',
    field: 'createDate',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_taskUpdateTime') || '更新时间',
    field: 'modifyDate',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
  },
]
